<template>
	<dv-full-screen-container>
		
		<div id="login-container">	
		  <div id="login-form">		
		    
			<h3 class="header">
		       {{logoTitle}}
		      <span>v3.2.1</span>
		    </h3>
		
			<img class="logo-img" :src="logo" alt="">
			
		    <!-- 输入用户名 -->
		    <div class="input-item">
		      <el-input v-model="userInfo.username"
		        clearable  placeholder="用户名" maxlength="20"   prefix-icon="el-icon-user"
				onkeyup="this.value=this.value.replace(/[^\w\u4e00-\u9fa5]/g,'')" >
		      </el-input>
		
		      <!-- 登录信息提示 -->
		      <p class="error-p">{{error_name}}</p>
		    </div>
		
		
		    <!-- 输入密码 -->
		    <div class="input-item">
		      <el-input   v-model="userInfo.password"
		        clearable placeholder="密码" prefix-icon="el-icon-lock"   show-password maxlength="20"
				onkeyup="this.value=this.value.replace(/[\s+]/g,'')"
		        @keyup.enter.native="loginHandle">
		      </el-input>
		
		      <!-- 登录信息提示 -->
		      <p class="error-p">{{error_password}}</p>
		    </div>
			
		    <button class="btn" ref="logbtn" :disabled="logbtn_use"  @click="loginHandle">登录</button>
		  </div>
		</div>
	</dv-full-screen-container>
</template>

<script>	
	import {dologin} from '@/api/login'
	export default {
		mounted() {},
		data() {
			return {
				userInfo: {
					username: '',
					password: ''
				},
				error_input: false,
				error_name: '',
				error_password: '',
				logbtn_use : false,
				// logoTitle:'兰大智能清洁机器人调度中心', //萝卜牛智慧调度中心 undefined
				// logo:require('../assets/img/logo-1.png'),
				logoTitle:localStorage.getItem('logoTitle')  == null
					? '萝卜牛智慧调度中心': localStorage.getItem('logoTitle')  == 'null'
						?  '萝卜牛智慧调度中心': localStorage.getItem('logoTitle')  == 'undefined' 
							? '萝卜牛智慧调度中心' : localStorage.getItem('logoTitle')+'调度中心', 
				logo:localStorage.getItem('logo')  == null
					? require('../assets/img/logo.png') : localStorage.getItem('logo')  == 'null' 
						? require('../assets/img/logo.png') : localStorage.getItem('logoTitle')  == 'undefined' 
							? require('../assets/img/logo.png') : localStorage.getItem('logo')
			}
		},
		methods: {
			loginHandle() {			
			  // 首先前端验证验证输入是否正确
			  this.check_inputs()		
			  if (!this.error_input) {  
				 this.setloginbtn(false)			  
				  dologin(this.userInfo).then(res => {
				  	var result = res.result
				  	if (result != 0) {
				  		var msg = res.message
				  		this.$message({
				  			message: '用户名或者密码错误',
				  			type: 'error'
				  		});
						this.setloginbtn(true)	
				  		return
				  	}
				  	if (result == 0) {
				  		localStorage.setItem('username', this.userInfo.username);
						localStorage.setItem('entityid', res.entityId);
						localStorage.setItem('token',res.authorization)
						
						localStorage.setItem('logoTitle',res.logoTitle)
						localStorage.setItem('logoMenu',res.logoMenu)
						localStorage.setItem('logo',res.logo)					
						
				  		//获取未登录的时候跳到登录页面的redirect地址
				  		const redirect = this.$route.query.redirect
				  		if (redirect) {
				  			//存在回跳地址就回跳
				  			this.$router.push(redirect)
				  		} else {
				  			//否则就跳到默认的首页
				  			// this.$router.push({
				  			// 	name: 'index'
				  			// })
							this.$router.replace('/index').catch(err => {
								console.log('all good')
							})
				  		}
				  
				  	}
				  });
			  }
			  this.error_input = false;
			},
			setloginbtn(aviabled){
				if(aviabled == false){		
					this.logbtn_use = true
					this.$refs.logbtn.style.backgroundColor='#948f8a'
					this.$refs.logbtn.innerHTML = '登录中' 
				}else{
					this.logbtn_use = false
					this.$refs.logbtn.style.backgroundColor='#00bca4'
					this.$refs.logbtn.innerHTML = '登录'
				}
			},
			check_inputs() {
			  if (this.userInfo.username === '') {
			    this.error_name = '用户名不能为空'
			    this.error_input = true
			  } else {
			    this.error_name = ''
			  }
			  if (this.userInfo.password === '') {
			    this.error_password = '密码不能为空'
			    this.error_input = true
			  } else {
			    this.error_password = ''
			  }
			},
		}
	}
</script>


<style lang="scss" scoped>
	#login-container {
	  text-align:center;
	  min-height: 100%;
	  width: 100%;
	  background-color: #2d3a4b;
	  overflow: hidden;
	
	}
	
	#login-form {	
	  position: relative;
	  width: 300px;
	  max-width: 100%;
	  padding: 70px 35px 0;
	  margin: 0 auto;	
	  overflow: hidden;
	
	}
	
	.header {
	  color: #c2c2c2;
	  font-size: 23px;
	  position: relative;
	  padding: 35px;
	}
	
	#login-form .logo-img {
	  height: 100px;
	  margin-top:-20px;
	  margin-bottom: 35px;
	}
	
	.input-item {	
	  border: 1px solid rgba(255,255,255,0.1);
	  background: rgba(0,0,0,0.1);
	  border-radius: 5px;
	  color: #454545;
	
	}
	
	.error-p {
	  font-size: 12px;
	  color: red;
	  text-align: left;
	}
	
	.btn {
	  color: #fff;
	  background-color: #00bca4;
	  height: 34px;
	  line-height: 12px;
	  border-radius: 3px;
	  border-color: #00a792;
	  width: 100%;
	  margin-bottom: 30px;
	}
</style>
